import React from "react";
import styled from "styled-components";

import ModulePanel from "../../ModulePanel";

const MobileChart = ({ mobileCount, size }) => {
    const [mobilePercent, setMobilePercent] = React.useState(0);
    
    React.useEffect(()=>{
        setMobilePercent(mobileCount * 100 / size);
    }, [mobileCount, size]);

    const desktopPercent = 100 - mobilePercent;

    return (
        <ModulePanel title={["Origen del Feedback"]}>
            <Container>
                <div>
                    <i className="fas fa-mobile-alt fa-2x" />
                    <div>
                        <div style={{ width: `${mobilePercent}%`}}></div>
                    </div>
                    <small>{mobilePercent.toFixed(0)}%</small>
                    <small>({mobileCount})</small>
                </div>
                <div>
                    <i className="fas fa-laptop fa-2x" />
                    <div>
                        <div style={{ width: `${desktopPercent}%` }}></div>
                    </div>
                    <small>{desktopPercent.toFixed(0)}%</small>
                    <small>({size - mobileCount})</small>
                </div>
            </Container>
        </ModulePanel>
    )
}

export default MobileChart;

const Container = styled.div`
    & > div{
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin: 8px 0;
        text-align: center;
    }

    & > div > div{
        flex: 3;
    }

    & > div > div{
        background: rgba(0, 0, 0, 0.14);
        border-radius: 4px;
    }
    & > div > div > div{
        background: var(--primary);
        border-radius: 4px;
        height: 12px;
    }

    & > div > i{
        flex: 2; 
    }

    & > div > small{
        flex: 1;
    }


`;